import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { of } from 'rxjs';
import { BreadcrumbsComponent } from './breadcrumbs.component';

@NgModule({
  imports: [CommonModule, RouterModule, UrlModule, MatIconModule, I18nModule, BreadcrumbsComponent],
  exports: [BreadcrumbsComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        BreadcrumbComponent: {
          component: BreadcrumbsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
    { provide: BreadcrumbsComponent },
    {
      provide: CmsComponentData,
      useValue: {
        data$: of({}),
      },
    },
  ],
})
export class BreadcrumbsModule {}
